import { Vue, Options } from 'vue-class-component';
import {
  AddressingType,
  EntrancePlantDetailDTO,
  EntrancePlantStructureCreateDTO,
  GateDTO,
} from '@/../client-generator/generated-clients/plants';
import { DenominationMode } from '@/../client-generator/generated-clients/plants';
import CardContainer from '@/views/components/CardContainer/CardContainer.vue';
import { toLabel } from '@/core/utils/EntrancePlant/denomination-helper';
import plantsClient from '@/core/services/plants';

@Options({
  name: 'DialogEntrancePlantCreateStep6',
  components: {
    CardContainer,
  },
  props: {
    plant: {
      required: true,
      type: Object as () => EntrancePlantDetailDTO,
    },
    plantId: {
      type: Number,
      required: false,
    },
    isEdit: {
      type: Boolean,
      default: false
    }
  },
  emits: ['is-loading', 'onBack', 'onNext', 'plant-edited'],
  computed: {},
})
export default class DialogEntrancePlantCreateStep6 extends Vue {
  plant!: EntrancePlantDetailDTO;
  plantId!: number;

  get titleCard() {
    return `${this.plant.gates?.length} ${this.$t(
      this.plant.gates?.length == 1
        ? 'AppResourceEP.Gate'
        : 'AppResourceEP.Gates'
    ).toString()}`;
  }

  get reachedMaxGates() {
    return this.plant.gates?.length === this.plant.scsAddressHelper?.availableScsAddressGate?.length;
  }

  addGate() {
    if (!this.plant.gates) this.plant.gates = [];
    if (this.reachedMaxGates) {
      return;
    }

    this.plant.gates.push(
      new GateDTO({
        name: this.getNewGateName(),
        apartments: [],
      })
    );
  }

  mounted(): void {
    if (!this.plant.gates || this.plant.gates.length === 0) {
      this.plant.gates = [];
      this.addGate();
    }
  }

  handleGateRemove(index: number) {
    if (!this.plant.gates) return;
    this.plant.gates.splice(index, 1);
  }

  private getNewGateName(): string {
    let newGateName: string;
    let counter = 0;
    do {
      counter++;
      newGateName = `${this.$t('AppResourceEP.Gate')} ${counter}`;
    } while (this.plant.gates?.some((x) => x.name == newGateName));
    return newGateName;
  }

  getDataToSave() {
    return new EntrancePlantStructureCreateDTO({
      wizardStep: 3,
      gateCreate: this.plant.gates,
    });
  }

  handleBackButton() {
    const prevPage =
      this.plant.addressingType !== AddressingType.BuildingRiserFloorApartment
        ? 'DialogEntrancePlantCreateStep3'
        : 'DialogEntrancePlantCreateStep5';
    this.$emit('onBack', prevPage);
  }
  async handleNextButton() {
    await this.updatePlantStructure(this.getDataToSave());
    this.$emit('onNext', 'DialogEntrancePlantCreateStep7');
  }
  async updatePlantStructure(structure: EntrancePlantStructureCreateDTO) {
    if (!this.plantId) return;
    this.$emit('is-loading', true);

    try {
      await plantsClient.structure(this.plant.desktopId!, structure);
    } catch (error) {
      this.$toast.add({
        severity: 'error',
        summary: this.$t('general.operationError'),
        closable: true,
        life: 6000,
      });
    } finally {
      this.$emit('is-loading', false);
    }
  }
}
